module.exports = __webpack_public_path__ + "img/app-icon.a162da70.svg";